import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";
import {
  getUserNuuid,
  parseUserNotifications,
} from "../../notifications/fcm-messaging";

const initialState = {
  token: null,
  registered: false,
  notifications: [],
};

const getCustomHeaders = () => ({
  "X-APP-KEY": process.env.VUE_APP_NOTIFICATIONS_APP_KEY,
  "X-USER-UUID": getUserNuuid(), // TODO: Get the id here?
});

const _refreshUserNotifications = async (commit) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const response = await restClient(
        path.client.messaging.notifications.base,
        "GET",
        null,
        null,
        getCustomHeaders()
      );
      commit(actions.GET_USER_NOTIFICATIONS, response);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export default {
  namespaced: true,
  name: "notifications",
  state: { ...initialState },
  mutations: {
    [actions.GET_USER_NOTIFICATIONS](state, payload) {
      state.notifications = parseUserNotifications(payload?.data?.data || []);
    },
    [actions.RESET_USER_NOTIFICATIONS](state) {
      state.notifications = [];
    },
    [actions.REGISTER_USER_TOKEN](state, payload) {
      state.token = payload?.token;
      state.registered = true;
    },
  },
  getters: {
    getUserNotifications: (state) => state.notifications,
  },
  actions: {
    async registerFCMToken({ commit }, payload) {
      const nuuid = getUserNuuid();
      await restClient(
        path.client.messaging.notifications[nuuid ? "clientTokens" : "tokens"],
        "POST",
        payload,
        null,
        getCustomHeaders()
      );
      commit(actions.REGISTER_USER_TOKEN);
      return _refreshUserNotifications(commit);
    },
    async refreshUserNotifications({ commit }) {
      return _refreshUserNotifications(commit);
    },
    async updateUserNotifications({ commit }, payload) {
      await restClient(
        path.client.messaging.notifications.single(payload.uuid),
        "PUT",
        payload,
        null,
        getCustomHeaders()
      );
      _refreshUserNotifications(commit);
    },
    async deleteUserNotifications({ commit }, payload) {
      await restClient(
        path.client.messaging.notifications.single(payload.uuid),
        "DELETE",
        null,
        null,
        getCustomHeaders()
      );
      _refreshUserNotifications(commit);
    },
    async resetNotifications({ commit }) {
      commit(actions.RESET_USER_NOTIFICATIONS);
    },
    async sendNotification(_, payload) {
      await restClient(
        path.admin.messaging.notifications.send,
        "POST",
        payload
      );
    },
  },
};
